export default __webpack_public_path__ + "static/media/crawlExplanation.ec6b3418.png";